import RentalContractRoute from './RentalContract';
import OwnershipContractRoute from './OwnershipContract';

export default {
	path: '/webview',
	components: () => [],
	render: (_, children) => children,
	children: [RentalContractRoute, OwnershipContractRoute],
};
